import { Grid, getStrWidth, removeHTMLTags, GridEvents } from "@dhx/ts-grid";
import { findIndex } from "@dhx/ts-common/core";
import { TreeGridCollection } from "./TreeGridCollection";
import { ITreeGridConfig, ITreeGrid } from "./types";
import { DropBehaviour } from "../../ts-data";

export class TreeGrid extends Grid implements ITreeGrid {
	data: TreeGridCollection;
	constructor(container: HTMLElement, config: ITreeGridConfig) {
		// [dirty]
		config.keyNavigation = false;

		super(container, config);
		// [dirty]
		if (!this.config.dropBehaviour) {
			this.config.dropBehaviour = DropBehaviour.sibling;
		}
		this.config.type = "tree";
	}
	scrollTo(row: string, col: string): void {
		const colInd = findIndex(this.config.columns, obj => obj.id === col);
		const fixedColsWidth = this.config.splitAt ?
			this.config.columns.slice(0, this.config.splitAt).reduce((total, c) => total += c.width, 0)
			: 0;
		const x = this.config.columns.slice(0, colInd).reduce((total, c) => total += c.width, 0) - fixedColsWidth;

		const y = this.data.getPlainIndex(row) * this.config.rowHeight;

		const scrollState = this.getScrollState();

		const gridRight = this.config.width + scrollState.x;
		const gridBottom = this.config.height + scrollState.y - (this.config.headerRowHeight * this.config.$headerLevel);

		const cellTop = y - scrollState.y - this.config.rowHeight;
		const cellLeft = x - scrollState.x - this.config.columns[colInd].width;

		const cellBottom = y + (this.config.rowHeight * 2) + 17 - gridBottom;
		const cellRight = x + (this.config.columns[colInd].width * 2) + 17 - gridRight;

		const scrollTop = (cellTop > 0 && cellBottom < 0) ? 0 : cellTop < 0 ? cellTop : cellBottom;
		const scrollLeft = (cellLeft > 0 && cellRight < 0) ? 0 : cellLeft < 0 ? cellLeft : cellRight;

		this.scroll(
			scrollLeft + scrollState.x,
			scrollTop + scrollState.y
		);
	}
	expand(id: string): void {
		if (this.data.haveItems(id)) {
			this.data.update(id, { $opened: true });
		}
	}
	collapse(id: string): void {
		if (this.data.haveItems(id)) {
			this.data.update(id, { $opened: false });
		}
	}
	expandAll(): void {
		this.data.eachChild(this.data.getRoot(), ({ id }) => this.expand(id));
	}
	collapseAll(): void {
		this.data.eachChild(this.data.getRoot(), ({ id }) => this.collapse(id));
	}
	protected _createCollection(prep: (data: any[]) => any[]) {
		this.data = new TreeGridCollection({
			prep
		}, this.events);
	}
	protected _checkColumns() {
		super._checkColumns();
		this._getTreeHeadersWidth();
	}
	protected _getRowIndex(rowId: any): number {
		return findIndex(this.data.serialize(), obj => obj.id === rowId);
	}
	protected _parseColumns() {
		super._parseColumns();
		if (this.config.columns.length) {
			this._getTreeHeadersWidth();
		}
	}
	protected _setEventHandlers() {
		super._setEventHandlers();

		this.events.on(GridEvents.expand, id => {
			const item = this.data.getItem(id);
			this.data.update(id, { $opened: !item.$opened });
		});

		this.events.detach(GridEvents.filterChange, this);
		this.events.on(GridEvents.filterChange, (val: any, colId: string, filter: string) => {
			this.data.filter();
			if (val) {
				this.data.filter({
					by: colId,
					match: val,
					compare: this.content[filter].match
				});
			}
		});

		// TODO: remove sute_7.0
		this.events.detach(GridEvents.headerInput, this);
		// TODO: remove sute_7.0
		this.events.on(GridEvents.headerInput, (val: any, colId: string, filter: string) => {
			this.data.filter();
			if (val) {
				this.data.filter({
					by: colId,
					match: val,
					compare: this.content[filter].match
				});
			}
		});
	}
	private _getTreeHeadersWidth() {
		if (this.config.columns[0].maxWidth || this.config.columns[0].minWidth || this.config.fitToContainer) {
			return;
		}
		const maxLevel = this.data.getMaxLevel();
		const firstCol = this.config.columns[0];
		const DEFAULT_PADDING = 10;
		const ICON_WIDTH = 35;
		const paddings = maxLevel * (DEFAULT_PADDING + ICON_WIDTH);
		let firstColWidth = 0;

		this.data.map(el => {
			firstColWidth = Math.max(
				getStrWidth(removeHTMLTags(`${el[firstCol.id]}`)),
				firstColWidth
			);

		});
		const newWidth = Math.max(firstColWidth + paddings, firstCol.width);
		this.config.$totalWidth = this.config.$totalWidth - firstCol.width + newWidth;
		this.config.columns[0].width = newWidth;
	}
}